import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { trackHover } from 'documents-lib/js/tracking/tracker';
import { CLICK_SHARE } from 'documents-lib/js/tracking/actions';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateLinkHoverButton = ({
  handleShowCreateLinkModal
}) => {
  return /*#__PURE__*/_jsx(Button, {
    onClick: () => {
      trackHover({
        action: CLICK_SHARE,
        type: 'share'
      });
      handleShowCreateLinkModal();
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "table.hoverButtons.createLink"
    })
  }, "share");
};
export default CreateLinkHoverButton;